import React, { useState } from 'react';
import { Text, Button, Loading, TagPreview } from 'ui';
import { useCampaign, useAuth, publishCampaign, unpublishCampaign, useCampaignTags, usePage, updatePage } from 'api';
import { useParams, Redirect } from 'react-router-dom';
import Info from './Info';
import Edit from './Edit';
import { green } from 'config/colors';
import "./index.css";


export default function ViewCampaign(props) {
  const { campaignId } = useParams();
  const auth = useAuth();
  const companyId = auth && auth.user.companyId;
  const campaign = useCampaign(companyId, campaignId);
  const tags = useCampaignTags(companyId, campaignId);
  const page = usePage(companyId, campaign && campaign.pageId);
  
  const [publishing, setPublishing] = useState(false);
  async function publish() {
    if(publishing) {
      return;
    }
    setPublishing(true);
    await publishCampaign(auth.user.companyId, campaignId);
    setPublishing(false);
  }
  async function unpublish() {
    if(publishing) {
      return;
    }
    setPublishing(true);
    await unpublishCampaign(auth.user.companyId, campaignId);
    setPublishing(false);
  }
  
  const [editing, setEditing] = useState(false);
  const toggleEditing = () => setEditing(!editing);
  
  if(!campaign) {
    return <Loading/>;
  }
  
  if(!campaign.name) {
    return <Redirect to="name"/>;
  }
  if(!campaign.slug) {
    return <Redirect to="slug"/>;
  }
  if(campaign.allTime !== true && (!campaign.start || !campaign.end)) {
    return <Redirect to="timeframe"/>;
  }
  if(campaign.allRegions !== true && !campaign.country) {
    return <Redirect to="region"/>;
  }
  
  return (
    <div className="campaignview">
      <div style={{height:80, display:'flex', flexDirection:'row', alignItems:'center'}}>
        <Text huge color={green} style={{flex:1}}>{campaign.name}</Text>
      </div>
      
      <div className="campaignview-wrapper">
      
        <div className="campaignview-info">
          
          <Text bold block style={{paddingBottom:8, borderBottom:'1px solid #aaa', marginBottom:24}}>Campaign Details:</Text>
          
          {
          // If we're editing, show the info form,
          // otherwise show info display.
          editing 
            ? <Edit campaign={campaign} onDone={toggleEditing}/>
            : <Info campaign={campaign} onEdit={toggleEditing}/>
          }
          
          <div style={{borderBottom:'1px solid #aaa', marginBottom:32}}/>
          
          <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
            {campaign.html && (
              campaign.unpublishedChanges ? (
                <Button 
                  onClick={publish} 
                  label={publishing ? "..." : "Publish Changes"} 
                  color="white" 
                  style={{backgroundColor:'#fe5000', marginRight:16}}
                />
              ) : (
                <Button 
                  label={publishing ? "..." : "Unpublish"} 
                  color="white" 
                  style={{backgroundColor:'#fe5000', marginRight:16}}
                  onClick={unpublish} 
                />
              )
            )}
            {(tags && tags.length > 0) &&
              <Button 
                to="add-tag"
                label="Add Tag" 
                color="white"
                style={{backgroundColor:'#fa637d', marginRight:16}}
              />
            }
            {campaign.datePublished && 
              <Button 
                to={`/reports/${campaignId}`}
                label="Report" 
                style={{backgroundColor:'#e3e5e4'}}
              />
            }
          </div>
          
          {/*
          List all tags associated with this campaign.
          */
          tags && tags.length > 0 && (
            <div>
              <Text block large color="#00b2a8" style={{marginBottom:24, marginTop:40}}>Campaign Tag(s)</Text>
              
              <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
                {tags.map(tag => {
                  return (
                    <div key={tag.id} style={{textAlign:'center', marginRight:32, marginBottom:32}}>
                      <TagPreview style={{height:200, marginBottom:16, boxShadow:'0 2px 4px rgba(0,0,0,0.3)'}} {...tag}/>
                      <div>
                        <Button label="Order Tags" color="white" to={`/tags/${tag.id}/order`} style={{backgroundColor:'#fa637d', marginRight:16}}/>
                        <Button label="Edit Design" to={tag.type === 'design' ? `/tags/${tag.id}/edit` : `/tags/${tag.id}/upload`} style={{backgroundColor:'#e3e5e4'}}/>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/*
          If we're still missing an element, prompt users to create them here.
          */
          (!campaign.pageId || !tags || tags.length === 0) && (
            <div>
              <Text block large style={{marginBottom:24, marginTop:40}}>
                Next Steps to complete your campaign.
              </Text>
              
              <div style={{display:'flex'}}>
                {(!tags || tags.length === 0) && (
                  <Button 
                    to="add-tag"
                    label="Add Tag" 
                    color="white"
                    style={{backgroundColor:'#fa637d', marginRight:16}}
                  />
                )}
                {!campaign.pageId && (
                  <Button 
                    to="add-page" 
                    label="Add Landing Page" 
                    color="white" 
                    style={{backgroundColor:'#00b2a8'}}
                  />
                )}
              </div>
            </div>
          )}
          
          
        </div>
        
        
        
        {page ? ( 
          <div className="campaignview-preview">
            
            <Text 
              bold block color={green} 
              style={{
                width: '100%',
                paddingTop:8, 
                borderTop:'1px solid #aaa', 
                marginBottom:24,
                marginTop: 27.2,
              }}>
              Campaign Landing Page
            </Text>
            
            
            {page.buildingPreview ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width:"100%",
                  height:80, 
                }}>
                <Text bold>Loading...</Text>
              </div>
            ) : page.preview ? (
              <img
                style={{
                  display: 'block',
                  width: 375,
                  height: 667,
                  boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
                  objectFit: 'cover',
                }}
                alt="Preview"
                onError={() => {
                  updatePage(companyId, campaign.pageId, {preview:null});
                }}
                src={page.preview}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width:"100%",
                  height:80, 
                }}>
                <Text bold>No Preview</Text>
              </div>
            )}
            
            {!page.buildingPreview &&
              <div style={{marginTop:-16, textAlign:'center', width:'100%'}}>
                <Button 
                  to={`/pages/${campaign.pageId}/edit`} 
                  label={"Edit Landing Page"} 
                  color="white" 
                  style={{backgroundColor:'#00b2a8', boxShadow: '0 2px 4px rgba(0,0,0,0.3)'}}/>
              </div>
            }
          </div>
        ) : (
          <div className="campaignview-preview"/>
        )}
        
      </div>
    </div>
  );
}